const ic_to_ai_magnifying_glass = require("./ic_to_ai_magnifying_glass.svg");
const ic_to_ai_report = require("./ic_to_ai_report.svg");
const ic_dislike_notint = require("./ic_dislike_notint.png");
const ic_dislike_tint = require("./ic_dislike_tint.png");
const ic_like_notint = require("./ic_like_notint.png");
const ic_like_tint = require("./ic_like_tint.png");
const ic_recycle_bin = require("./ic_recycle_bin.png");

export {
  ic_to_ai_magnifying_glass,
  ic_to_ai_report,
  ic_like_notint,
  ic_like_tint,
  ic_dislike_notint,
  ic_dislike_tint,
  ic_recycle_bin,
};
